module.exports = __webpack_public_path__ + "static/media/SF-Pro-Display-Ultralight.bc55c63e.otf";